import React, { useState } from "react";

const VaultBalanceNotationsGrid = ({ columnsData, columnDetail }) => {
  const [expandedCurrencies, setExpandedCurrencies] = useState(new Set());

  const toggleCurrency = (currency) => {
    setExpandedCurrencies(prev => {
      const newSet = new Set(prev);
      if (newSet.has(currency)) {
        newSet.delete(currency);
      } else {
        newSet.add(currency);
      }
      return newSet;
    });
  };

  const columns = Object.keys(columnDetail).map(originalKey => {
    const detail = columnDetail[originalKey];
    return {
      key: originalKey,
      header: detail.title || originalKey,
      width: detail.width || 'auto',
      align: originalKey === 'Currency' ? 'left' : 'right'
    };
  });

  const groupedData = columnsData.reduce((acc, row) => {
    if (!acc[row.Currency]) acc[row.Currency] = [];
    acc[row.Currency].push(row);
    return acc;
  }, {});

  const currencies = Object.keys(groupedData);

  return (
    <div style={{ height: "80vh", overflow: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
        <thead>
          <tr>
            {columns.map(col => (
              <th key={col.key} style={{ border: "1px solid #ddd", padding: "8px", textAlign: col.align, width: col.width }}>
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currencies.map(currency => {
            const rows = groupedData[currency];
            const isExpanded = expandedCurrencies.has(currency);
            const totalRow = rows.find(r => r["Denomination Description"] === "Total");
            const denominationRows = rows.filter(r => r["Denomination Description"] !== "Total");
            const hasDenominations = denominationRows.length > 0;

            return (
              <React.Fragment key={currency}>
                {totalRow && (
                  <tr
                    onClick={() => hasDenominations && toggleCurrency(currency)}
                    style={{ cursor: hasDenominations ? "pointer" : "default", backgroundColor: "#f0f0f0", fontWeight: "bold" }}
                  >
                    {columns.map(col => (
                      <td key={col.key} style={{ border: "1px solid #ddd", padding: "8px", textAlign: col.align, width: col.width }}>
                        {col.key === 'Currency' ? `${hasDenominations ? (isExpanded ? "▼" : "▶") : ""} ${totalRow.displayCurrency || totalRow[col.key]}` : totalRow[col.key]}
                      </td>
                    ))}
                  </tr>
                )}
                {isExpanded && denominationRows.map((row, index) => (
                  <tr key={`${currency}-${index}`}>
                    {columns.map(col => (
                      <td key={col.key} style={{ border: "1px solid #ddd", padding: "8px", textAlign: col.align, width: col.width }}>
                        {col.key === 'Currency' ? '' : row[col.key]}
                      </td>
                    ))}
                  </tr>
                ))}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default VaultBalanceNotationsGrid;
